// A card "uses counters" when its box text tracks level counters. It
// either adds them (add_counter op) or gates on the current count
// (cast_cost_equals_counter condition). The renderer shows a centred
// counter token for such cards from level 0 onward. The Immortal Throne
// is the only one today; keying off automation shape (not a name list)
// means any future counter card lights up automatically.
export function cardUsesCounters(fullCard) {
  return (fullCard?.automation || []).some((e) =>
    (e.effect || []).some((f) => f.op === 'add_counter')
    || e.condition?.type === 'cast_cost_equals_counter');
}
